import { Component, input } from '@angular/core';
import { StyleService, GalaxyTheme } from '@vendasta/galaxy/style-service';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'atlas-dark-mode-toggle',
  templateUrl: './dark-mode-toggle.component.html',
  styleUrls: ['./dark-mode-toggle.component.scss'],
  standalone: false,
})
export class DarkModeToggleComponent {
  themeContext = input<string>('atlas');
  
  protected readonly currentTheme = toSignal(this.styleService.activeTheme$);
  protected readonly GalaxyTheme = GalaxyTheme;

  constructor(private styleService: StyleService) {
    this.styleService.update(this.themeContext(), this.currentTheme());
  }

  protected toggleColorScheme(): void {
    this.styleService.toggleLightDark(this.themeContext());
  }
}
